import roles from './roles';

/**
 * Papéis com acesso a qualquer rota do painel (/painel/*).
 * Clientes finais (USER) e garçons (WAITER) ficam de fora e são
 * redirecionados para a listagem pública de eventos.
 */
export const DASHBOARD_ROLES = [roles.PRODUCER, roles.ESTABLISHMENT, roles.ADMIN];

/** Papéis com acesso ao painel do produtor (/painel/produtor/*). */
export const PRODUCER_ROLES = [roles.PRODUCER, roles.ESTABLISHMENT, roles.ADMIN];

/** Papéis com acesso ao painel do estabelecimento (/painel/estabelecimento/*). */
export const ESTABLISHMENT_ROLES = [roles.ESTABLISHMENT, roles.ADMIN];

export function hasRole(user, allowedRoles) {
    return allowedRoles.some((role) => role == user?.role?.id);
}

/**
 * Quem foi convidado só para algum evento (convite direto ou equipe) e não tem
 * papel de painel: abre o painel do produtor como ele mesmo, só em Eventos e
 * Check-in, e dentro de cada evento só o que o produtor liberou. Quem entrou
 * por uma equipe de painel age como o produtor e não cai aqui.
 */
export function isEventCollaboratorOnly(user) {
    return !!user?.is_event_collaborator && !user?.acting_as && !hasRole(user, DASHBOARD_ROLES);
}

export function canAccessDashboard(user) {
    return hasRole(user, DASHBOARD_ROLES) || isEventCollaboratorOnly(user);
}

/**
 * A pessoa de verdade tem painel próprio? Dentro do painel de um produtor
 * `user` é o produtor, então quem vale é o membro que entrou por ele.
 */
export function actorHasOwnPanel(user) {
    const roleId = user?.acting_as ? user.acting_as.member?.role_id : user?.role?.id;

    return hasRole({ role: { id: roleId } }, DASHBOARD_ROLES);
}
